import React from 'react';

import { Container } from './styles';

import nodata from '../../assets/nosearch.svg';

function NotFound({ children, title, img = nodata }) {
  return (
    <Container>
      <img src={img} alt="Dados não encontrados" />
      <span>
        {!!title && <h2>{title}</h2>}
        <h3>{children}</h3>
      </span>
    </Container>
  );
}

export default NotFound;
